import type MapView from '@arcgis/core/views/MapView';
import type { PropsWithChildren } from 'react';
import { createContext, useCallback, useContext, useRef } from 'react';
import * as React from 'react';

const MapViewContextComponent = createContext<MapViewContext>(
  null as unknown as MapViewContext
);

type MapViewContext = {
  view: MapView;
  setView: (view: MapView) => void;
};

export const MapViewProvider = ({ children }: PropsWithChildren) => {
  const viewRef = useRef<MapView>(null as unknown as MapView);
  const setView = useCallback((view: MapView) => (viewRef.current = view), []);

  return (
    <MapViewContextComponent.Provider
      value={{
        view: viewRef.current,
        setView
      }}
    >
      {children}
    </MapViewContextComponent.Provider>
  );
};

export const useMapView = () => useContext(MapViewContextComponent)?.view;

export const useInitializeMapView = () => {
  const viewRef = useMapView();
  const setViewRef = useContext(MapViewContextComponent)?.setView;

  return useCallback(
    (view: MapView) => {
      if (!viewRef) setViewRef(view);
      if (view) {
        view.popupEnabled = false;
      }
    },
    [setViewRef, viewRef]
  );
};
